import { render } from "./SubmittedView.vue?vue&type=template&id=508ed0bd"
import script from "./SubmittedView.vue?vue&type=script&lang=js"
export * from "./SubmittedView.vue?vue&type=script&lang=js"

import "./SubmittedView.vue?vue&type=style&index=0&id=508ed0bd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__